export default "/images/4e85a4d5391e3d33cdc66274b1615713.avif";